import rootSortConfig from './roots-sort.config'

export default [
  ...rootSortConfig,
  // {
  //   title: 'Slug по возрастанию',
  //   field: 'slug.asc',
  //   options: {
  //     by: 'slug',
  //     order: 'asc'
  //   }
  // },
  // {
  //   title: 'Slug по убыванию',
  //   field: 'slug.desc',
  //   options: {
  //     by: 'slug',
  //     order: 'desc'
  //   }
  // },
  // {
  //   title: 'Название ссылки (А-Я)',
  //   field: 'link_title.asc',
  //   options: {
  //     by: 'link_title',
  //     order: 'asc'
  //   }
  // },
  // {
  //   title: 'Название ссылки (Я-А)',
  //   field: 'link_title.desc',
  //   options: {
  //     by: 'link_title',
  //     order: 'desc'
  //   }
  // },
  // {
  //   title: 'Ссылка (А-Я)',
  //   field: 'link.asc',
  //   options: {
  //     by: 'link',
  //     order: 'asc'
  //   }
  // },
  // {
  //   title: 'Ссылка (А-Я)',
  //   field: 'link.desc',
  //   options: {
  //     by: 'link',
  //     order: 'desc'
  //   }
  // },
]